import { tabbables as d } from "../../constants/tabbables.js";
const l = (a) => [...a.querySelectorAll(d.join(","))].filter((e) => {
  const t = e.getAttribute("aria-disabled") === "true" || e.hasAttribute("disabled"), n = getComputedStyle(e), i = n.display === "none" || n.visibility === "hidden";
  return !t && !i;
}).map((e, t) => ({
  node: e,
  tabIndex: e.tabIndex,
  index: t
})).sort((e, t) => {
  const n = Math.max(0, e.tabIndex), i = Math.max(0, t.tabIndex), s = n - i, r = e.index - t.index;
  return s ? n ? i ? s : -1 : 1 : r;
});
export {
  l as getFocusableElements
};
